// extracted by mini-css-extract-plugin
module.exports = {"container":"FIqeR","postMainActionContainer":"_2n53N","wrapper":"_3NNdB","iconLeft":"AzRvV","iconRight":"KtGkz","postMainActionIcon":"_3ZzKd","postMainActionWrapper":"_2SnTi"};